<template lang="pug">
    .tips(:class="{'tips_multiplayer': forMultiplayer}")
        .tips__header(v-if="!forMultiplayer")
            description-button.tip-button(
                :arrow-icon-rotated="true",
                @toggle-show-tip-variable="$emit('toggle-show-tip-variable')"
            )
        .tips__body
            svg-icon.tips__arrow-icon.tips__arrow-icon_left(
                v-if="tips && tips.length > 1"
                @click.native='showPrevTip'
                @mousedown.native.stop,
                :class="{'tips__arrow-icon_disabled': currentTipIndex === 0}"
                name="angle-left",
                size="x-large",
            )
            .tip(:style="{'overflow-y': tip.content === 'hard-soft-consonants.jpg' && 'auto'}")
                transition(:name="transitionName" mode="out-in")
                    .tip_transitioned(:key="currentTipIndex")
                        .image-tip(
                            :style="stylesForHardSoftConsonantsGame",
                            v-if="tip.type === 'image'",
                            @touchstart="event => stopPropagationIfScrollable(event)",
                            @touchmove="event => stopPropagationIfScrollable(event)"
                        )
                            img.image-tip__image(
                                :src="tipImage"
                            )
                        .text-tip(v-else-if="tip.type === 'text'")
                            span.text-tip__text(
                                v-html="tip.content"
                            )
                        .text-tip(v-else-if="tip.type === 'translation'")
                            span.text-tip__text
                              | {{ $i18n.t(`trainer.trainer_gameFormSetting_${tip.content}`) }}
            svg-icon.tips__arrow-icon.tips__arrow-icon_right(
                v-if="tips && tips.length > 1"
                @click.native='showNextTip'
                @mousedown.native.stop,
                :class="{'tips__arrow-icon_disabled': currentTipIndex === lastTipIndex}"
                name="angle-right",
                size="x-large",
            )
</template>

<script>
    import DescriptionButton from './DescriptionButton.vue';

    const SLIDE_TRANSITIONS = {
        left: 'slide-left',
        right: 'slide-right',
    };

    export default {
        props: {
            tips: {
                type: Array,
                required: true,
            },
            forMultiplayer: {
                type: Boolean,
                default: false,
            },
        },
        mounted() {
            this.getWindowDimensions();
            window.addEventListener('resize', this.onResize);
            this.isTipScrollable = !window.matchMedia('only screen and (min-width: 576px)').matches;
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        data() {
            return {
                currentTipIndex: 0,
                lastTipIndex: this.tips.length - 1,
                transitionName: SLIDE_TRANSITIONS.right,
                isTipScrollable: false,
                windowWidth: null,
                windowHeight: null,
            };
        },
        computed: {
            tip() {
                return this.tips[this.currentTipIndex];
            },
            tipImage() {
                return require(`../../../assets/images/trainer/game-tips/${this.tip.content}`);
            },
            stylesForHardSoftConsonantsGame() {
                if (this.tip.content === 'hard-soft-consonants.jpg') {
                    if (this.windowWidth < 576) {
                        return { width: 'auto' };
                    } else {
                        return {
                            display: 'flex',
                            width: '340px',
                            height: '340px',
                            'justify-content': 'center',
                        };
                    }
                } else {
                    return {};
                }
            },
        },
        methods: {
            getWindowDimensions() {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            },
            onResize() {
                this.getWindowDimensions();
            },
            showPrevTip() {
                if (this.currentTipIndex !== 0) {
                    this.transitionName = SLIDE_TRANSITIONS.left;
                    this.currentTipIndex--;
                }
            },
            showNextTip() {
                if (this.currentTipIndex !== this.lastTipIndex) {
                    this.transitionName = SLIDE_TRANSITIONS.right;
                    this.currentTipIndex++;
                }
            },
            stopPropagationIfScrollable(event) {
                if (this.isTipScrollable) {
                    event.stopPropagation();
                }
            },
        },
        components: {
            DescriptionButton,
        },
    };
</script>

<style lang="scss" scoped>
    @mixin tip-styles($header-height, $content-height, $content-width) {
        .tips {
            display: flex;
            flex-direction: column;

            height: $header-height + $content-height;
            padding: 0 10px 10px;
            border-radius: 35px;
            box-shadow: 0 0 9px rgba(51, 51, 51, 0.1);

            background: $x-color-white;

            @include media($sm) {
                padding: 0 15px 10px;
            }
            @include media($lg) {
                padding: 0 20px 15px;
            }
            @include media($xl) {
                padding: 0 30px 20px;
            }
        }

        .tips_multiplayer {
            height: $content-height;
            padding-bottom: 0;
            padding-top: 20px;
            box-shadow: none;
        }

        .tip-button {
            margin-top: 5px;
        }

        .tips__header {
            display: flex;
            height: $header-height;
            justify-content: flex-end;
        }

        .tips__body {
            display: flex;
            align-items: center;
        }

        .tips__arrow-icon {
            color: $hsl-color-blue-56_5;
        }
        .tips__arrow-icon:hover {
            cursor: pointer;
        }
        .tips__arrow-icon_right {
            margin-left: 3px;
            @include media($sm) {
                margin-left: 20px;
            }
        }
        .tips__arrow-icon_left {
            margin-right: 3px;
            @include media($sm) {
                margin-right: 20px;
            }
        }
        .tips__arrow-icon_disabled {
            color: $hsl-color-gray-52;
        }
        .tip {
            display: flex;
            align-items: center;
            font-size: $font-size-14;
            text-align: center;
            height: $content-height;
            overflow-y: auto;
            overflow-x: auto;
            width: $content-width;

            @include media($sm) {
                overflow-y: hidden;
                overflow-x: hidden;
                font-size: $font-size-16;
            }
            @include media($md) {
                font-size: $font-size-18;
            }
            @include media($lg) {
                font-size: $font-size-20;
            }
        }

        .tip_transitioned {
            width: 100%;
            height: 100%;
            @include media($sm) {
                display: flex;
                justify-content: center;
            }
        }

        .image-tip {
            display: flex;
            align-items: center;
            width: 340px;
            @include media($sm) {
                width: auto;
                height: $content-height - 10px;
            }
            padding-bottom: 10px;
        }

        .image-tip__image {
            width: 340px;
            @include media($sm) {
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
            }
            display: block;
            pointer-events: none;
        }

        .text-tip {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            overflow-y: auto;
            @include media($md) {
                overflow-y: visible;
            }
        }

        .text-tip__text {
            display: inline-block;
            line-height: 20px;
            @include media($lg) {
                line-height: 30px;
            }
        }

        .slide-left-enter-active,
        .slide-right-enter-active {
            transition: 0.5s;
        }

        .slide-right-enter {
            transform: translate(115%, 0);
        }

        .slide-left-enter {
            transform: translate(-115%, 0);
        }
    }

    @include tip-styles(43px, 120px, 260px);

    @include media($sm) {
        @include tip-styles(60px, 140px, 320px);
    }

    @include media($md) {
        @include tip-styles(60px, 160px, 350px);
    }

    @include media($lg) {
        @include tip-styles(70px, 170px, 420px);
    }

    @include media($xlg) {
        @include tip-styles(70px, 180px, 440px);
    }

    @include media($xl) {
        @include tip-styles(70px, 200px, 500px);
    }
</style>
